import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AppNavBarLayout from './AppNavBarLayout';
import { useSelector } from "react-redux";
import { history } from "../components/helpers/History";
import { USER_ROLE } from "../components/security/UserRole";

export const PrivateRoute = ({ component: Component,authorized:authorized, ...rest }) => {
    const loggedInUser = useSelector(state => state.authentication.user);
    const userRole = useSelector(state => state.authentication.userRole);
    const isUserLoggedIn = loggedInUser && loggedInUser.id && loggedInUser.username;
    const isAuthorizedUser = loggedInUser && loggedInUser.userRole && authorized && authorized.indexOf(loggedInUser.userRole) >=0;
    if(!isAuthorizedUser){
        if(userRole===USER_ROLE.SYSTEM_ADMIN || userRole===USER_ROLE.HCP_ADMIN){
            history.push('/admin/home');
          }else if(userRole===USER_ROLE.DOCTOR){
            history.push('/doctor/home');
          }else {
            history.push('/home');
          }
    }
    return(
    <Route {...rest} render={props => (
        isUserLoggedIn
            ?<AppNavBarLayout><Component {...props} /></AppNavBarLayout>
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />);
}